import request from 'api/requestUtils'

const METASEARCH_DISCOUNT_API_TIMEOUT_MS = 5000

export interface ResolveMetasearchDiscountInput {
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  /** Full displayed price, inclusive of property fees. Also the request cache key. */
  price: number
  /**
   * Property-fees portion of `price` (payable at the property). Forwarded so the resolver can
   * base margin_retention on the inclusive price (`price − propertyFees`). Not part of the cache
   * key — `price` alone keys the request, keeping write/read lookups aligned.
   */
  propertyFees?: number
  occupancy: Array<string>
  mx?: string
}

export interface ResolveMetasearchDiscountResponse {
  discountAmount: number
}

export function resolveMetasearchDiscount(
  input: ResolveMetasearchDiscountInput,
): Promise<ResolveMetasearchDiscountResponse> {
  return request.post<ResolveMetasearchDiscountResponse, ResolveMetasearchDiscountInput>(
    '/api/connections/google/discount-resolve',
    input,
    { timeout: METASEARCH_DISCOUNT_API_TIMEOUT_MS },
  ).then(response => ({
    discountAmount: response?.discountAmount ?? 0,
  })).catch(() => ({
    discountAmount: 0,
  }))
}
